<template>
  <BaseModal :id="`ModalAddInstructor`" :size="'md'" title="Add assessor" @closeModal="closeModal">
    <div class="d-flex flex-column align-items-center">
      <div class="w-100">
        <BaseInput
          id="input-add-instructor"
          ref="input-add-instructor"
          v-model="email"
          input-type="search-input"
          label=""
          placeholder="Input teacher email"
          :is-invalid="submitFail"
          @keyupEnter="getInstructor"
        />
      </div>

      <div v-if="isFinding" class="p-2">
        <b-spinner label="Loading..." variant="dark" />
      </div>
      <Instructor v-if="instructor && !isFinding" class="w-100" :instructor="instructor" />

      <div v-if="isNotFound" ref="not--found--records" class="text-dark py-2">
        No matching records found.
      </div>
    </div>

    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="hide()"> Cancel </b-button>

      <b-button
        ref="button-add-instructor"
        :disabled="!instructor || instructor.tag === $constants.TAG.ADDED"
        variant="primary"
        @click="addInstructor"
      >
        <span v-if="!isLoading">Add</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base-components/BaseModal';
import BaseInput from '@/components/base-components/BaseInput';
import Instructor from './Instructor';
import LearningUnitMember from '@/models/LearningUnitMember';
import UserRole from '@/models/UserRole';
import User from '@/models/User';
import Utility from '@/models/Utility';

export default {
  components: {
    BaseModal,
    BaseInput,
    Instructor
  },
  props: {
    learningUnitId: {
      type: [Number, String],
      default: null
    },

    memberUserIds: {
      type: Array,
      default: () => []
    },

    role: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isLoading: false,
      isFinding: false,
      submitFail: false,
      email: '',
      // instructors: [],
      instructor: null,
      isNotFound: false
    };
  },

  computed: {
    user() {
      return User.query().first();
    },
    currentRole() {
      return this.role ? UserRole.role(this.role) : null;
    }
  },

  methods: {
    async addInstructor() {
      this.isLoading = true;

      try {
        if (!this.instructor || !this.instructor.id || !this.learningUnitId || !this.currentRole)
          return;

        await LearningUnitMember.api().addLearningUnitMember({
          user: this.instructor.id,
          learning_unit: this.learningUnitId,
          user_role: this.currentRole.id
        });

        this.$emit('onAddNewMember', this.instructor);

        this.$toast.success('The assessor was added successfully');
      } catch (error) {
        console.error(error);
        this.$toast.error('Cannot add assessor, please try again');
      } finally {
        this.isLoading = false;
      }

      this.hide();

      this.reset();
    },

    async getInstructor() {
      this.isFinding = true;
      let { email } = this;

      email = email.trim();

      if (email && email.length) {
        this.instructor = null;
        this.isNotFound = false;

        try {
          let promise = await Utility.api().findUserByEmail(email);
          const { data } = promise.response;

          if (data) {
            this.instructor = {
              id: data.id,
              firstname: data.firstname,
              lastname: data.lastname,
              email: data.email,
              tag: this.memberUserIds.indexOf(data.id) !== -1 ? 'added' : null,
              profile_picture: data.profile_picture
            };
          } else {
            this.isNotFound = true;
          }
        } catch (error) {
          console.error(error);
          this.$toast.error('Cannot find assessor, please try again');
        }
      } else {
        this.isNotFound = true;
      }

      this.isFinding = false;
    },

    reset() {
      this.email = '';
      this.instructor = null;
      this.isNotFound = false;
    },

    show() {
      this.$bvModal.show(`ModalAddInstructor`);
    },
    hide() {
      this.$bvModal.hide(`ModalAddInstructor`);
    },

    closeModal() {
      this.reset();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 2rem;
}
</style>
